import { render, staticRenderFns } from "./WidgetReproActes.vue?vue&type=template&id=472a1000&"
import script from "./WidgetReproActes.vue?vue&type=script&lang=js&"
export * from "./WidgetReproActes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports